import {
  ChuginTermsOfPolicyDataProvisionPage,
  TermsOfPolicyDataProvisionPage,
} from "@/components/pages";
import { FFGTermsOfPolicyDataProvisionPage } from "@/components/pages/terms/FFGTermsOfPolicyDataProvisionPage";
import { BankCode } from "@/libs/constants";

type Props = {
  bankName: string;
  bankCode: BankCode;
  bankFormalName: string;
  dataProvisionRegulationDate: string;
  dataProvisionRevisionDate: string;
  additionalProviders?: string[];
  isInsuranceAgency?: boolean;
};

export const DataProvisionPolicy = (props: Props) => {
  switch (props.bankName) {
    case "MF銀行":
      break;
    case "MF第二銀行":
      break;
    case "福岡銀行":
      return <FFGTermsOfPolicyDataProvisionPage {...props} />;
    case "十八親和銀行":
      return <FFGTermsOfPolicyDataProvisionPage {...props} />;
    case "熊本銀行":
      return <FFGTermsOfPolicyDataProvisionPage {...props} />;
    case "横浜信用金庫":
      break;
    case "千葉興業銀行":
      break;
    case "徳島大正銀行":
      break;
    case "四国銀行":
      break;
    case "中国銀行":
      return <ChuginTermsOfPolicyDataProvisionPage {...props} />;
    case "栃木銀行":
      break;
    case "群馬銀行":
      break;
    case "八十二銀行":
      break;
    case "広島銀行":
      break;
    case "京都銀行":
      break;
    case "常陽銀行":
      break;
    case "静岡銀行":
      break;
    case "長野銀行":
      break;
    case "富山第一銀行":
      break;
    case "Demo銀行":
      break;
    case "多摩信用金庫":
      break;
    case "西日本シティ銀行":
      break;
    case "伊予銀行":
      break;
    case "沖縄銀行":
      break;
    case "京都信用金庫":
      break;
    case "南都銀行":
      break;
    case "宮崎銀行":
      break;
    case "琉球銀行":
      break;
    case "山形銀行":
      break;
    case "第四北越銀行":
      break;
    case "秋田銀行":
      break;
    case "あいち銀行":
      break;
    case "北日本銀行":
      break;
    case "武蔵野銀行":
      break;
    case "⁠滋賀銀行":
      break;
    case "福井銀行":
      break;
    case "北海道信用金庫":
      break;
    case "七十七銀行":
      break;
    case "知多信用金庫":
      break;
    case "あいおいニッセイ同和損保":
      break;
    case "あずさ監査法人":
      break;
    case "ゆうちょ銀行":
      break;
    case "南日本銀行":
      break;
    case "アエジス銀行":
      break;
  }

  return <TermsOfPolicyDataProvisionPage {...props} />;
};
